angular.module('elogbooksServices').service('siteAccessConfirmationModal', ['$uibModal', function ($uibModal) {
    return {
        open: function (config) {
            return $uibModal.open({
                templateUrl: '/modules/common/modals/site-access-confirmation/site-access-confirmation.html',
                controller: 'SiteAccessConfirmationModalController',
                controllerAs: 'vm',
                resolve: {
                    config: function () {
                        var defaultConfig = {
                            titleMessage: 'ARE_YOU_SURE_SHORT',
                            bodyMessage: 'SITE_ACCESS_CONFIRMATION_MESSAGE',
                            primaryText: 'YES',
                            primaryClass: 'btn-danger',
                            secondaryText: 'NO',
                            secondaryClass: 'btn-default',
                            sites: [],
                            translateValues: {}
                        };

                        return angular.extend({}, defaultConfig, config);
                    }
                }
            });
        }
    };
}]);
